import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import ModalLayout from '../../../components/Layout/ModalLayout';
import { formDataConverter } from '../../../utils/necessaryFunctions';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';
import VisaForm from '../../../components/Forms/Websites/Visa/VisaForm';

const Visa = () => {
    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');
    const navigate = useNavigate();

    const { result, isLoading, setRefresh } = useFetch(() => request.getAll('visa'));

    const columns = [
        {
            name: 'Name',
            center: 'true',
            selector: (row) => row?.name,
        },
        {
            name: 'Image',
            width: '100px',
            cell: (row) => (
                <img
                    style={{ width: '100%' }}
                    // src={`url(${process.env.REACT_APP_UPLOAD_URL}/website/${row?.image})`}
                    src={`${process.env.REACT_APP_UPLOAD_URL}/website/${row?.image}`}
                    alt='Visa'
                />
            ),
        },
        {
            name: 'Price',
            wrap: true,
            center: 'true',
            selector: (row) => row?.price,
        },
        {
            name: 'Discount',
            wrap: true,
            center: 'true',
            selector: (row) => row?.package_discount,
        },
        // {
        //     name: 'Required_documents',
        //     wrap: true,
        //     center: 'true',
        //     width: '200px',
        //     selector: (row) => <div dangerouslySetInnerHTML={{ __html: row?.required_documents }} />,
        // },
        {
            name: 'Country',
            wrap: true,
            center: 'true',
            width: '200px',
            selector: (row) => row?.destination?.country_name,
        },
        {
            name: 'Visa Mode',
            wrap: true,
            center: 'true',
            width: '200px',
            selector: (row) => row?.visa_mode,
        },
        {
            name: 'Visa Type',
            wrap: true,
            center: 'true',
            width: '200px',
            selector: (row) => row?.visa_type?.name,
        },
        {
            name: 'Max stays',
            wrap: true,
            center: 'true',
            selector: (row) => row?.max_stays,
        },
        {
            name: 'Validity',
            wrap: true,
            center: 'true',
            selector: (row) => row?.validity,
        },
        // {
        //     name: 'Description',
        //     wrap: true,
        //     center: 'true',
        //     width: '200px',
        //     selector: (row) => <div dangerouslySetInnerHTML={{ __html: row?.description }} />,
        // },
        {
            name: 'Success Count',
            wrap: true,
            center: 'true',
            width: '200px',
            selector: (row) => row?.success_count,
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Active',
            center: 'true',
            cell: (row) => (
                <div>
                    <EditButton
                        // onClick={() => {
                        //     setModalOpen('update');
                        //     setSelectedItem(row);
                        // }}
                        onClick={() => navigate(`/dashboard/website/visa/edit/${row?.id}`)}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // create new function

    const createNewServiceHandler = (formValue) => {
        const formData = formDataConverter(formValue);

        request.create('visa', formData, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // update

    const updateServiceHandler = (formValue) => {
        const formData = formDataConverter(formValue);

        request.updateOne('visa', selectedItem?.id, formData, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // delete

    const deleteServiceHandler = () =>
        request.delete('visa', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Visa List'
            buttonTitle='Add New Visa'
            // addButtonHandler={() => setModalOpen('create')}
            addButtonHandler={() => navigate('/dashboard/website/visa/add')}
        >
            <ReactDataTable data={result} columns={columns} pending={isLoading} />
            {/*= ============== create ===================== */}

            {/* {modalOpen === 'create' && (
                <ModalLayout
                    isOpen={modalOpen === 'create'}
                    onClose={() => setModalOpen('')}
                    title='Create New visa'
                    size='lg'
                >
                    <VisaForm apiHandler={createNewServiceHandler} />
                </ModalLayout>
            )} */}

            {/* ======================= update ========================== */}

            {modalOpen === 'update' && (
                <ModalLayout
                    isOpen={modalOpen === 'update'}
                    onClose={() => setModalOpen('')}
                    title='Update New Destination'
                    size='lg'
                >
                    {/* <VisaForm apiHandler={updateServiceHandler} /> */}
                    <CrudFormLayout
                        initialValues={initialValues}
                        buttonCenter
                        apiHandler={formHandler}
                        validationSchema={validationSchema}
                    >
                        <VisaForm />
                    </CrudFormLayout>
                </ModalLayout>
            )}

            {/* ======================= delete ========================== */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={deleteServiceHandler}
                />
            )}
        </CardLayout>
    );
};

export default Visa;
